<app-page-heading [key]="'user-dashboard.blueyonder-user.list.page-title'" [carriers]="carriers"
                  [carrierSelectPlaceholderKey]="'selects.carriers.default-placeholder'"
                  (selectedCarrierChange)="selectedCarrierChanged($event)" [selectedCarrier]="carrier"
                  [clearable]="false" [helper]="true" [helperContent]="helper">
</app-page-heading>


<section class="container-fluid summary-panel">
    <div *ngIf="!showCarrierSelectionHelper; else landingPage" class="m-b-md">
        <app-data-table [loadObservable]="loadingSubject.asObservable()"
                        [columns]="columns"
                        [loadPage]="loadPage"
                        [showColumnsSelection]="false"
                        [noOverflow]="true">
            <app-data-buttons>
                <button class="btn btn-primary btn-lg pull-right" (click)="goToCreateBlueyonderUser()">
                    <span>
                        <i class="fa fa-plus"></i>&nbsp;
                        <span class="text-uppercase" [i18n]="'user-dashboard.blueyonder-user.list.buttons.create'"></span>
                    </span>
                </button>
            </app-data-buttons>
        </app-data-table>
    </div>

    <ng-template #landingPage>
        <div class="landing-page">
            <i class="fa fa-arrow-up"></i>
            <h1 [i18n]="'user-dashboard.blueyonder-user.list.helper.line4'"></h1>
        </div>
    </ng-template>
</section>

<ng-template #userCodeColumn let-userCode="userCode">
    {{ userCode }}
</ng-template>

<ng-template #userNameColumn let-userName="userName">
    {{ userName }}
</ng-template>

<ng-template #userGroupColumn let-userGroup="userGroup">
    {{ userGroup }}
</ng-template>

<ng-template #actionsColumn let-blocked="blocked" let-item="item">
    <dropdown-actions>
        <div class="dropdown-item">
            <button class="btn btn-primary btn-sm m-r-xs" [disabled]="blocked" (click)="goToResetBlueyonderUser(item)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.blueyonder-user.list.table.actions.reset-blueyonder-user.tooltip'}]">
                <span>
                    <i class="fa fa-undo"></i>&nbsp;
                    <span [i18n]="'user-dashboard.blueyonder-user.list.table.actions.reset-blueyonder-user.label'"></span>
                </span>
            </button>
        </div>
        <div class="dropdown-item">
            <button class="btn btn-danger btn-sm m-r-xs" (click)="goToDeleteBlueyonderUser(item)"
                    [i18n]="[{target: 'attribute:title', key: 'user-dashboard.blueyonder-user.list.table.actions.delete-blueyonder-user.tooltip'}]">
                <span>
                    <i class="fa fa-trash"></i>&nbsp;
                    <span [i18n]="'user-dashboard.blueyonder-user.list.table.actions.delete-blueyonder-user.label'"></span>
                </span>
            </button>
        </div>
    </dropdown-actions>
</ng-template>

<ng-template #deleteModal let-user="user">
    <span [i18n]="[{ target: 'innerHTML', key: 'user-dashboard.blueyonder-user.modal.delete.warning', params: { user: user }}]"></span><br>
</ng-template>

<ng-template #resetModal let-user="user">
    <span [i18n]="[{ target: 'innerHTML', key: 'user-dashboard.blueyonder-user.modal.reset.warning', params: { user: user }}]"></span><br>
    <div class="alert-wrapper">
        <div class="alert alert-info">
            <i class="fa fa-info-circle m-r"></i>
            <div [i18n]="'user-dashboard.blueyonder-user.modal.reset.for-more-security'"></div>
        </div>
    </div>
</ng-template>

<ng-template #helper>
    <h3 class="text-primary text-left" [i18n]="'user-dashboard.blueyonder-user.list.helper.title'"></h3>
    <spacer [size]="8"></spacer>
    <div class="text-left">
        <ul>
            <li><span [i18n]="'user-dashboard.blueyonder-user.list.helper.line1'"></span></li>
            <li><span [i18n]="'user-dashboard.blueyonder-user.list.helper.line2'"></span></li>
            <li><span [i18n]="'user-dashboard.blueyonder-user.list.helper.line3'"></span></li>
        </ul>
    </div>
</ng-template>

